module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAABUklEQVRIx2NgSDImiO6oyJOBGEaNJtnoBKMbytQ22iBbKSqbPzOPK9GHpc6Pc6+9GHWM9kkXzg02rE3ybEywnRhpsyTUrdLfaE4QL6VGV1ZxdNczx9lzLTZWKrMRKrURnmcmH23DVZnO0hXGSZHRKekcrTUsBy1Nrq1cse/kPSC6ungRkLtFT2xLAQ/5RjPGG2ZnsHkFccU7cU6rq9xy6Nbmg7cmVxUmOPKUuXHWpLBeo8TojBRW11De+Ta6a7qnbjl4c/PBG6s6Ji601S2y4qpJY7lBSYBEZ/PLJaj0hdlVOavsOnB1+4ErjR6a8xPtp8dyTozmoiisA1L5S3JZkxOUip2FL5roXzA1LHQRbsmUn9vLMiWek9LE55khFp0nYJUu35FrPyfNbpGbSH8cx6QQ7ltUyTI66YrROQJZ+ZydaexTYrm2WYsOhYw+WqhS12gA97s2NoQLmmcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/pt.png
// module id = 906
// module chunks = 0